export default __webpack_public_path__ + "static/media/catherine.b58fa5ca.bin";